import React, { forwardRef } from 'react';

import { MobileSlideIn } from '@pdcfrontendui/components';
import { Prettify } from '@pdcfrontendui/types';
import { useIsDualView } from '@pdcfrontendui/hooks';
import useParallax from '../hooks/useParallax';

// Plain Omit would collapse the ariaLabel/ariaLabelledBy exclusive union in
// MobileSlideIn's props into one type that satisfies neither arm.
type DistributiveOmit<T, K extends keyof T> = T extends unknown
  ? Omit<T, K>
  : never;

function SlideInPre(
  props: Prettify<
    DistributiveOmit<
      Parameters<typeof MobileSlideIn>[0],
      'bottom' | 'isMobile'
    > & {
      noAnimation?: boolean;
    }
  >,
  ref: React.Ref<HTMLDivElement>
) {
  const dualView = useIsDualView();

  useParallax(!!props.children && !dualView && !props.noAnimation);
  return (
    <MobileSlideIn
      {...props}
      bottom={50}
      isMobile={!dualView && !props.noAnimation}
      ref={ref}
    />
  );
}

export const SlideIn = forwardRef(SlideInPre);
